<template>
  <v-data-table
    :headers="headers"
    :items="transactionLimits"
    hide-default-footer
  >
    <template #header.action>
      <v-icon @click="isAddingNewItem = true">
        add
      </v-icon>
    </template>

    <template #body.prepend>
      <operator-limit-editor
        v-if="isAddingNewItem"
        :transactionLimit="getEmptyTransactionLimit()"
        @save="$emit('save', $event)"
        @close="isAddingNewItem = false"
      />
    </template>

    <template #item="{item}">
      <component
        :is="getItemComponent(item)"
        :transaction-limit="item"
        :expenditure="expenditureByType[item.type]"
        @edit="limitIdToEdit = item.transaction_limit_id"
        @close="limitIdToEdit = null"
        @save="$emit('save', $event)"
        @delete="$emit('delete', item.transaction_limit_id)"
      />
    </template>
  </v-data-table>
</template>

<script>
import OperatorLimitView from './OperatorLimitView.vue'
import OperatorLimitEditor from './OperatorLimitEditor.vue'

export default {
  components: {
    OperatorLimitEditor
  },
  props: {
    transactionLimits: {
      type: Array,
      default: () => ([])
    },
    expenditureByType: {
      type: Object,
      default: () => ({})
    },
    isLoading: Boolean
  },

  data() {
    return {
      headers: [
        { text: '#', value: 'transaction_limit_id', sortable: false },
        { text: 'Type', value: 'type' },
        { text: 'Min', value: 'min_limit' },
        { text: 'Max', value: 'max_limit' },
        { text: 'Daily', value: 'daily_limit' },
        { text: 'Weekly', value: 'weekly_limit' },
        { text: 'Monthly', value: 'monthly_limit' },
        { text: '', value: 'action', sortable: false },
      ],
      isAddingNewItem: false,
      limitIdToEdit: null,
    }
  },

  methods: {
    getItemComponent(item) {
      return item.transaction_limit_id === this.limitIdToEdit ? OperatorLimitEditor : OperatorLimitView;
    },
    getEmptyTransactionLimit() {
      return {
        daily_limit: 0,
        max_limit: 0,
        min_limit: 0,
        monthly_limit: 0,
        weekly_limit: 0
      }
    }
  },

  watch: {
    isLoading(newValue, oldValue) {
      if (oldValue && !newValue) {
        this.limitIdToEdit = null;
        this.isAddingNewItem = false;
      }
    }
  }
}
</script>
